
<template>
  <div>
    <v-row>
      <v-col cols="12">
        <naj-input
          :type-id="formFieldType.radioButton"
          :value.sync="answerId"
          :label="rootItem.text"
          :items="rootItem.answers"
          item-value="id"
          item-text="text"
          :validates="localValidates"
          :disabled="disabled"
          @change="onAnswer(answerId,true)"
        ></naj-input>
      </v-col>
    </v-row>
    <v-row v-if="nextItem != null">
      <v-col cols="12">
        <naj-tree-node
          :key="selectedAnswer ? selectedAnswer.id : null"
          :root-item="nextItem"
          :items-list="itemsList"
          :node-result-value="nodeResultValue"
          :preselected-answers="preselectedAnswers"
          :disabled="disabled"
          @all-selections="onChildAnswer"
          @final-result="onChildFinalResult"
        >
        </naj-tree-node>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'NajTreeNode',
  components: {},
  props: {
    rootItem: {
      type: Object,
      default: () => ({}),
    },
    itemsList: {
      type: Array,
      default: () => ([]),
    },
    nodeResultValue: { type: String },
    validates: {
      type: Array,
      default: () => [],
    },
    preselectedAnswers: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedAnswer: null,
      nextItem: null,
      answerId: null,
      localValidates: [],
      hasInitialized: false,
    };
  },
  computed: {
    combined() {
      return [this.rootItem, this.preselectedAnswers];
    },
  },

  watch: {
    combined: {
      handler([val1, val2]) {
        if (!this.hasInitialized && val1 && val1.id != undefined && val2 && val2.length > 0) {
          this.hasInitialized = true;
          this.setInitialAnswer();
        }
      },
      immediate: true,
    },

  },
  methods: {

    setInitialAnswer() {
      const found = this.preselectedAnswers.find(
        ans => ans.questionId === this.rootItem.id
      );
      if (found && found.selectedAnswerId != undefined) {
        this.answerId = found.selectedAnswerId;
        this.onAnswer(found.selectedAnswerId, false);
      }
    },
    onAnswer(e, isActualChange) {
      if (e != undefined) {
        this.localValidates = [];
        this.nextItem = null;
        this.selectedAnswer = this.rootItem.answers.find(x => x.id == e);
        if (this.selectedAnswer != null) {
          this.$emit('all-selections', {
            res: {
              questionId: this.rootItem.id,
              questionText: this.rootItem.text,
              selectedAnswer: this.selectedAnswer,
              remainingAnswers: this.rootItem.answers,
            },
            isActualChange: isActualChange,
          });
          if (this.selectedAnswer.nextQuestionId != null) {
            this.nextItem = this.itemsList.find(x => x.id == this.selectedAnswer.nextQuestionId);
          } else {
            var resultsNode = this.selectedAnswer.resultsNode;
            if (resultsNode.type == 'reject') {
              this.localValidates = [`required|error:${resultsNode.text}`];
            } else {
              var res = resultsNode[`${this.nodeResultValue}`];
              this.$emit('final-result', {
                res: res,
                isActualChange: isActualChange,
              });
            }
          }
        }
      }
    },
    onChildAnswer(answer) {
      this.$emit('all-selections', answer);
    },
    onChildFinalResult(res) {
      this.$emit('final-result', res);

    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-input--radio-group {
  .options-list {
    display: inline !important;
  }
}

::v-deep .v-input--radio-group {
  .v-messages {
    margin-top: 10px;
  }
}

.res-div {
  background: #dddddd;
  padding: 10px;
  border: 1px solid #a4a4a4;
  border-radius: 6px;
  font-size: larger;
}
.res-row {
  padding: 10px;
  min-height: 151px;
}
.tree-option {
  max-width: 1828px;
  overflow-x: auto;
  width: 1828px !important;
  white-space: nowrap;
}
</style>

